import React, { useEffect, useState } from "react";
import Logo from "../../assets/img/logo/logorumneo.svg";
import { NavLink, useLocation } from "react-router-dom";


const Mainnav = () => {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [isProductsOpen, setIsProductsOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("Home");

  const toggleNavbar = () => {
    setIsNavbarOpen(!isNavbarOpen);
    setIsProductsOpen(false);
    setIsServicesOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (isNavbarOpen) {
        setIsNavbarOpen(false);
      }
      if (isProductsOpen) {
        setIsProductsOpen(false);
      }
      if (isServicesOpen) {
        setIsServicesOpen(false)
      }
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [isNavbarOpen, isProductsOpen, isServicesOpen]);



  const location = useLocation();


  const handleLinkClick = (link) => {
    setActiveLink(link);

    setIsProductsOpen(link === "Products" ? !isProductsOpen : false);
    setIsServicesOpen(link === "Services" ? !isServicesOpen : false);
  };

  const isRouteActive = (pathname, routeList = []) => {
    return routeList.some((route) => pathname.includes(route));
  };
  const active = isRouteActive(location.pathname, [
    "/allproducts",
    "/goatproduct",
    "/cattleproduct",
    "/poultryproduct",
    "/dogproduct",
    "productDetails",
  ]);


  return (
    <nav
      className="navbar navbar-expand-lg navbar-light py-2 position-fixed w-100 bg-sky-blue-color"
    // style={{ backgroundColor: "#DDF0F8" }}
    >
      <div className="container-fluid px-lg-5 px-3 d-flex">
        <a className="navbar-brand me-lg-2 me-0" href="/#">
          <img
            src={Logo}
            alt="Logo"
            style={{ width: "68px", height: "68px" }}
          />
        </a>

        {/* Action Buttons  for mobile screen*/}
        <div className="d-lg-none d-flex justify-content-end align-items-center ms-auto">
        </div>

        <button
          className="navbar-toggler px-1 ms-1"
          type="button"
          onClick={toggleNavbar}
          aria-expanded={isNavbarOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className={`navbar-collapse custom-collapse ${isNavbarOpen ? "custom-collapse-show" : ""
            }`}
          id="navbarNav"
        >
          {/* Links Section */}
          <ul className="navbar-nav gap-lg-4 me-auto mb-2 mb-lg-0 text-center">
            <NavLink to={"/"} className={"text-decoration-none"}>
              <li className="nav-item">
                <div
                  className={`nav-link ${String(location?.pathname) === "/" ? "active" : ""
                    }`}
                  onClick={() => handleLinkClick("Home")}
                >
                  Home
                </div>
              </li>
            </NavLink>

            <li className="nav-item">
              <div
                className={`nav-link ${String(location?.pathname) === "/products" ||
                  String(location?.pathname) === "/allproducts" ||
                  String(location?.pathname) === "/goatproduct" ||
                  String(location?.pathname) === "/cattleproduct" ||
                  String(location?.pathname) === "/poultryproduct" ||
                  String(location?.pathname) === "/dogproduct" ||
                  String(location?.pathname) === "/equipment" ||
                  String(location?.pathname) === "/humanCunsumable" ||
                  String(location?.pathname) === "/cropseed"
                  ? "active"
                  : " "}`}
                onClick={() => handleLinkClick("Products")}
              // aria-expanded={isProductsOpen}
              >
                Products
              </div>
              <div
                //  ref={dropdownRef}
                className={`products-collapse shadow mt-2 w-100 rounded-bottom-5 ${isProductsOpen ? "show" : ""
                  }`}
              >
                <div className="products-collapse-list gap-4 ms-lg-5 py-3">
                  <div className="ms-4">
                    <p className="products-title text-start">
                      VETERINARY PRODUCTS
                    </p>
                    <ul className="list-unstyled products-list text-start">
                      <NavLink
                        to={"/allproducts"}
                        className="text-decoration-none"
                      >
                        <li>All Animal Supplements</li>
                      </NavLink>
                      <NavLink
                        to="/goatproduct"
                        className="text-decoration-none"
                      >
                        <li>Goat Supplements</li>
                      </NavLink>
                      <NavLink
                        to="/cattleproduct"
                        className="text-decoration-none"
                      >
                        <li>Cattle Supplements</li>
                      </NavLink>
                      <NavLink
                        to="/poultryproduct"
                        className="text-decoration-none"
                      >
                        <li>Poultry Supplements</li>
                      </NavLink>
                      <NavLink
                        to="/dogproduct"
                        className="text-decoration-none"
                      >
                        <li>Dog Supplements</li>
                      </NavLink>
                      {/* <li>Poultry Supplements</li> */}
                    </ul>
                  </div>
                  <div>
                    <p className="products-title text-start">
                      OTHER CATEGORIES
                    </p>
                    <ul className="list-unstyled products-list text-start">
                      <NavLink
                        to={"/equipment"}
                        className="text-decoration-none"
                      >
                        <li>Farmhouse Equipments</li>
                      </NavLink>
                      <NavLink to={"/humanCunsumable"} className="text-decoration-none">
                        <li>Human Consumable</li>
                      </NavLink>
                      <NavLink to={"/cropseed"} className="text-decoration-none">
                        <li>Crop Seeds</li>
                      </NavLink>
                    </ul>
                  </div>
                  {/* <div>
                    <p className="products-title text-start">GOAT FOR SELL</p>
                    <ul className="list-unstyled products-list text-start">
                      <li>Lorem Ipsum</li>
                    </ul>
                  </div> */}
                </div>
              </div>
            </li>

            <li className="nav-item">
              <div
                className={`nav-link ${String(location?.pathname) === "/service" ||
                  String(location?.pathname) === "/faq" ||
                  String(location?.pathname) === "/consulting" ||
                  String(location?.pathname) === "/goatfarming" ||
                  String(location?.pathname) === "/dairyconsultant"
                  ? "active"
                  : ""
                  }`}
                // href=""
                onClick={() => handleLinkClick("Services")}
              >
                Services
              </div>
              <div
                className={`products-collapse shadow mt-2 w-100 rounded-bottom-5 ${isServicesOpen ? "show" : ""
                  }`}
              >
                <div className="products-collapse-list gap-5 ms-lg-5 py-3 px-1">
                  <div className="ms-lg-4 ms-2">
                    <p className="products-title text-start text-uppercase">
                      VETERINARY Services
                    </p>
                    <ul className="list-unstyled products-list text-start">
                      <NavLink to="/service#Veterinary" className="text-decoration-none">
                        <li className="cursor">Why Choose US?</li>
                      </NavLink>
                      <NavLink to="/consulting" className="text-decoration-none">
                        <li className="cursor">Our Consulting team members</li>
                      </NavLink>
                      <NavLink
                        to={"/service#Business"}
                        className="text-decoration-none"
                      >
                        <li className="cursor">Business Startup Support </li>
                      </NavLink>
                      <NavLink
                        to={"/service#QueryForm"}
                        className="text-decoration-none"
                      >
                        <li className="cursor">Query Form</li>
                      </NavLink>
                      {/* <li>Poultry Supplements</li> */}
                    </ul>
                  </div>
                  <div>
                    <p className="products-title text-start text-uppercase">
                      Goat Farming Consultant
                    </p>
                    <ul className="list-unstyled products-list text-start">
                      <NavLink
                        to={"/goatfarming"}
                        className="text-decoration-none"
                      >
                        <li>About</li>
                      </NavLink>
                      <NavLink
                        to={"/faq"}
                        className="text-decoration-none"
                      >
                        <li className="cursor">FAQs</li>
                      </NavLink>
                    </ul>
                  </div>
                  <div className="me-2">
                    <p className="products-title text-start text-uppercase">
                      dairy consultant
                    </p>
                    <ul className="list-unstyled products-list text-start">
                      <NavLink
                        to={"/dairyconsultant#Service"}
                        className="text-decoration-none"
                      >
                        <li>About</li>
                      </NavLink>
                      <NavLink
                        to={"/dairyconsultant#DairyManagement"}
                        className="text-decoration-none"
                      >
                        <li>Dairy Management</li>
                      </NavLink>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            <NavLink to={"/blog"} className={"text-decoration-none"}>
              <li className="nav-item">
                <div
                  className={`nav-link ${String(location?.pathname) === "/blog" ? "active" : ""
                    }`}
                  onClick={() => handleLinkClick("Blogs")}
                >
                  Blogs
                </div>
              </li>
            </NavLink>
            <NavLink to={"/contactus"} className={"text-decoration-none"}>
              <li className="nav-item">
                <div
                  className={`nav-link ${String(location?.pathname) === "/contactus" ? "active" : ""
                    }`}
                  onClick={() => handleLinkClick("Contact Us")}
                >
                  Contact Us
                </div>
              </li>
            </NavLink>
            
            
          </ul>
        </div>


      </div>
    </nav>
  );
};

export default Mainnav;
